import { TourStateData } from "@nicsmith/shared_types";
import { baseApi } from "./api";

export const tourApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    updateTourState: builder.mutation<{ ok: true }, TourStateData>({
      query: (tourState) => ({
        url: `/users/me/tour-state`,
        method: "PATCH",
        body: tourState,
      }),
    }),
  }),
  overrideExisting: true,
});

export const { useUpdateTourStateMutation } = tourApi;
